/**
 * Pure type + normalization utilities for the `accountRequests` schema.
 * Kept out of `firebaseService.ts` so tests can import without the
 * firebase mocks in `tests/setup.ts` swallowing the exports.
 */

export type AccountRequestStatus =
  | 'draft'
  | 'pending'
  | 'in_review'
  | 'approved'
  | 'declined'
  | 'onboarding'
  | 'live';

/** Statuses accepted from external callers (legacy `'rejected'` allowed at the
 * boundary; service helpers fold it into `'declined'` before write). */
export type AccountRequestStatusInput = AccountRequestStatus | 'rejected';

export const ACCOUNT_REQUEST_STATUSES: AccountRequestStatus[] = [
  'draft',
  'pending',
  'in_review',
  'approved',
  'declined',
  'onboarding',
  'live',
];

export const normalizeAccountRequestStatus = (
  raw: string | undefined | null,
): AccountRequestStatus => {
  if (raw === 'rejected') return 'declined';
  if (raw && (ACCOUNT_REQUEST_STATUSES as string[]).includes(raw)) {
    return raw as AccountRequestStatus;
  }
  return 'pending';
};
